import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  sortNumeric,
  selectFormat,
  getMetricForColumn,
  Error,
} from "components/Utils/Utils.js";
import paginationFactory from "react-bootstrap-table2-paginator";

class LeeAtGlance extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable = (data) => {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "newsletter",
        text: "Newsletter",
        formatter: (cell) => cell.charAt(0).toUpperCase() + cell.slice(1),
        csvFormatter: (cell) => cell,
        style: { width: "150px", minWidth: "150px" },
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "sent_unique",
        text: "Sent",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "delivered_unique",
        text: "Delivered",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "delivered_rate",
        text: "Unique Delivered Rate",
        style: { width: "140px", minWidth: "160px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "opened_unique",
        text: "Opened",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "open_rate",
        text: "Unique Open Rate",
        style: { width: "120px", minWidth: "140px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "clicked_unique",
        text: "Clicked",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "ctr",
        text: "CTR",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "unsubscribed_unique",
        text: "Unsubscribed",
        style: { width: "80px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "unsubscribe_rate",
        text: "Unique Unsubscribe Rate",
        style: { width: "160px", minWidth: "160px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "message_type",
        text: "Message Type",
        formatter: (cell) => cell.charAt(0).toUpperCase() + cell.slice(1),
        csvFormatter: (cell) => cell,
        style: { width: "120px", minWidth: "120px" },
        sort: true,
      },
      {
        dataField: "sent",
        text: "Unique Sends",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "delivered",
        text: "Unique Delivered",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "delivered_rate",
        text: "Unique Delivered Rate",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "opened",
        text: "Unique Opens",
        style: { width: "100px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "open_rate",
        text: "Unique Open Rate",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "clicked",
        text: "Unique Clicks",
        style: { width: "100px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "click_thru_rate",
        text: "CTOR",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "unsubscribed",
        text: "Unique Unsubscribes",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "unsubscribe_rate",
        text: "Unsubs Rate",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "converted",
        text: "Conversions",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "converted_rate",
        text: "Conversion Rate",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }
    const defaultSorted = [
      this.props.url.includes("lee/customer-io-newsletter")
        ? {
            dataField: "sent_unique",
            order: "desc",
          }
        : {
            dataField: "message_type",
            order: "desc",
          },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    const pagination = paginationFactory({
      sizePerPage: 15,
      hideSizePerPage: true,
    });

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            pagination={
              this.props.url.includes("customer-io-newsletter")
                ? pagination
                : null
            }
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.data;

    if (this.props.data.hasData === false) {
      return <Error minHeight={200} />;
    }

    let table_data = data;

    return this.renderTable(table_data);
  }
}

export default LeeAtGlance;
